function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnreadMarker = function SvgUnreadMarker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 7
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 0C6.344.656 6.344.656 7 1.75c.348 1.758.273 3.047-.656 4.594-1.547.93-2.836 1.004-4.594.656C.656 6.344.656 6.344 0 5.25-.348 3.492-.273 2.203.656.656 2.203-.274 3.492-.348 5.25 0m0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#009ada",
      fillOpacity: 1
    }
  }));
};
export default SvgUnreadMarker;